import { Typography } from "@material-ui/core";
import * as React from "react";
import { useState } from "react";
import { CenteredContainer } from "../components/CenteredContainer/CenteredContainer";
import { BlueButton } from "../components/Buttons/BlueButton";
import * as EmailAction from "../../stores/emails/EmailAction";
import { useParams } from "react-router-dom";
import { useDispatchWithError } from "../../hooks/useDispatchWithError";
import ToastStatusEnum from "../../constants/ToastStatusEnum";
import { useSnackbar } from "notistack";

interface IEmailVerificationProps {}

export const EmailVerificationView: React.FunctionComponent<IEmailVerificationProps> = () => {
    const { emailVerificationCode } = useParams();
    const [verified, setVerified] = useState<boolean>(false);
    const { enqueueSnackbar } = useSnackbar();

    const [dispatchWithError, verifyEmailError] = useDispatchWithError(
        EmailAction.REQUEST_VERIFY_ADDITIONAL_EMAIL_FINISHED,
        () => {
            enqueueSnackbar("Email verified", { variant: ToastStatusEnum.Info });
            setVerified(true);
        }
    );

    const handleVerify = () => {
        dispatchWithError(EmailAction.verifyAdditionalEmail(emailVerificationCode));
    };

    return (
        <CenteredContainer>
            {verified ? (
                <Typography variant="h5" gutterBottom>
                    The email address has been verified.
                </Typography>
            ) : (
                <div>
                    <Typography variant="h5" gutterBottom>
                        Please verify your email address.
                    </Typography>
                    {verifyEmailError && (
                        <Typography variant="h5" gutterBottom color="error">
                            Verification failed. Either the email has already been verified or the link is invalid.
                        </Typography>
                    )}
                    <BlueButton onClick={handleVerify}>Verify</BlueButton>
                </div>
            )}
        </CenteredContainer>
    );
};
